import { Trans, useTranslation, language } from "gatsby-plugin-react-i18next";

const ActivityTracking = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 act-track">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Empower <br/>Your Team's <br/>Daily Activity!</Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                        <Trans>Fuel your employees' wellness journey - every step, run <br/>and ride matters!</Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label red-font">
                                        <Trans>Step Success</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Step Counter</Trans></h2>
                                    <p className='section-para font-weight-normal no-br'><Trans>Discover the benefits of daily walks for your team. <br/>Each step is a stride towards improved health.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='d-flex justify-content-end px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1705992316/VantageFit/2023/Activity_Tracker-Step_counter`)} fetchPriority="high" alt="Step Counter" width="667" height="815"/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label green-font">
                                    <Trans>Run Rhythm</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Run Towards Goals</Trans></h2>
                                    <p className='section-para font-weight-normal'><Trans>Track runs and witness employee health progress.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img px-0'>
                                <div className='col-12 d-flex justify-content-start px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1705992316/VantageFit/2023/Activity_Tracker-Run_rhythm`)} loading='lazy' alt="Run Towards Goals" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label orange-font">
                                    <Trans>Cycle Sync</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Ride the Wellness Wave</Trans></h2>
                                    <p className='section-para font-weight-normal'><Trans>Capture employee cycling adventures. Strike a balance: work and pedal-powered wellbeing.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='d-flex justify-content-end px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1705992316/VantageFit/2023/Activity_Tracker-cycle_sync`)} loading='lazy' alt="Ride the Wellness Wave" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label green-font">
                                    <Trans>Log Activity</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Comprehensive Activity Logging</Trans></h2>
                                    <p className='section-para font-weight-normal'><Trans>Record various activities spanning well-being, cardiovascular exercises, sports and beyond in multiple categories.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='col-12 d-flex justify-content-start px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706617939/vantagecircle/new-assets/Activity_Tracker-log_activity`)} loading='lazy' alt="Comprehensive Activity Logging" width="621" height="759"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative container">
                <div className="section-heading-top cursive">
                    <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat1">Upgrade Your &nbsp;<span className="charmonman green-clr">Routine</span></Trans>&nbsp;!</h2>
                    <div className="section-para text-center"><Trans>Enhance well-being with intuitive tracking tailored for your employees.</Trans></div>
                </div>
            </section>

            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                            <Trans>Embrace the Leap</Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5 text-white">
                            <Trans>With Vantage Fit, make every step, run and ride count for your team.</Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default ActivityTracking;
